import React from "react";

const ChevronIcon: React.FC<{ opened: boolean }> = ({ opened }) => (
  <div className={`chevron-icon chevron-icon--${opened ? 'opened' : 'closed'}`}>
    <svg
      className="chevron-icon__svg"
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="8"
      viewBox="0 0 24 24"
    >
      <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z" />
    </svg>
  </div>
);

export default ChevronIcon;